import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, select } from 'redux-saga/effects';

import { $httpRootApi, getCancelRequestSource, yieldFailureResponse, yieldSuccessResponse } from '@core/http-client';
import { societyAcquisitionInsightsActions } from '@redux/reducers/insights/society-acquisition/societyAcquisitionInsightsReducer';
import { societyAcquisitionInsightsSelectors } from '@redux/selectors/insights/societyAcquisitionInsights';
import { GetSocietyInsightsFilteringRequestPayload } from '@redux/types/insights/insightsTypes';
import {
  GetSocietyAcquisitionInsightsResponse,
  SocietyAcquisitionInsightsState,
} from '@redux/types/insights/society-acquisition/societyAcquisitionInsightsTypes';
import { showNotification } from '@shared/components/notification';
import { getDefaultError, getQueriesAsSearch } from '@shared/utils/common';

export function* getSocietyAcquisitionInsightsSaga(action: PayloadAction<GetSocietyInsightsFilteringRequestPayload>) {
  const source = getCancelRequestSource();

  yield put(societyAcquisitionInsightsActions.setListLoading(true));

  const { error, response }: GetSocietyAcquisitionInsightsResponse = yield call(() =>
    $httpRootApi
      .get(`/society/acquisitions/statistics${getQueriesAsSearch(action.payload)}`, {
        cancelToken: source.token,
      })
      .then(yieldSuccessResponse)
      .catch(yieldFailureResponse)
  );

  if (response) {
    yield put(societyAcquisitionInsightsActions.getListSuccess(response.data));
  } else if (error) {
    const errorMessage = getDefaultError(error.response?.data?.message || error.message);

    // Set the societies invalid flag
    if (error.response?.status === 403) {
      yield put(societyAcquisitionInsightsActions.setListSocietiesInvalid(true));
    }

    // Show error notification
    showNotification(errorMessage, 'error');

    // Set the message / errors list
    yield put(societyAcquisitionInsightsActions.getListFailure(errorMessage));
  }

  const { loading }: SocietyAcquisitionInsightsState = yield select(societyAcquisitionInsightsSelectors.getState);
  if (loading) {
    source.cancel();
  }
}
